import { ComponentProps } from 'react';
import Button from 'shared/Button';
import { Dialog } from './Dialog';

type ConfirmDialogProps = {
    cancelButtonText: string;
    confirmButtonText: string;
    onConfirm: () => void;
} & Omit<ComponentProps<typeof Dialog>, 'footer'> &
    Partial<Pick<ComponentProps<typeof Button>, 'color' | 'loading'>>;

export const ConfirmDialog = ({
    cancelButtonText,
    color,
    confirmButtonText,
    loading,
    onConfirm,
    ...props
}: ConfirmDialogProps) => {
    const ConfirmButtons = (
        <>
            <Button color="light" outline onClick={props.onClose}>
                {cancelButtonText}
            </Button>
            <Button color={color} loading={loading} onClick={onConfirm}>
                {confirmButtonText}
            </Button>
        </>
    );

    return <Dialog footer={ConfirmButtons} {...props} />;
};
